import React from 'react'
import { Portlet, Divider, Button, Col, Row } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as SaldosInicialesCrud from 'services/saldosIniciales.service'

import DetallesSection from './detalles'

const actualizarFila = (current, { cantidad, precio, ...restPayload }) => {
  current = {
    ...current,
    ...restPayload,
    cantidad,
    precio
  }

  current.subTotal = current.cantidad * current.precio

  return current
}

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'actualizar': {
      const { aplicarTodos, saltarFila, ...nuevoPayload } = action.payload
      return state.map(val => {
        if (val.esFilaBusqueda) {
          val.__filaActiva = saltarFila
        } else {
          if (val._idFila === nuevoPayload._idFila) {
            val = actualizarFila(val, nuevoPayload)
          }
          val.__filaActiva = !saltarFila
        }
        val.toDo = 2
        return val
      })
    }
    case 'actualizarComentario':
      return state.map((val, i) => {
        if (val._idFila === action.payload._idFila) {
          val.comentario = action.payload.comentario
        }
        return val
      })
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const DetallesSectionPortlet = ({ registros, successSubmitHandler }) => {
  const __zariContext = React.useContext(ZariContext)

  const [detalles, detallesDispatcher] = React.useReducer(commonReducer, registros)

  const clickGuardarCambiosHandler = React.useCallback(() => {
    const detallesNormalizados = detalles.map(x => {
      return {
        _id: x._id,
        cantidad: parseInt(x.cantidad),
        precio: parseFloat(x.precio),
        toDo: x.toDo
      }
    })

    SaldosInicialesCrud.actualizarSoloDetalles({
      detalles: detallesNormalizados
    }).then(() => {
      __zariContext.snack('success', 'Los registros se han actualizado')
      successSubmitHandler()
    })
  }, [detalles, successSubmitHandler, __zariContext])

  return (
    <Portlet>
      <Portlet.Body>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickGuardarCambiosHandler}>Guardar Cambios</Button>
          </Col>
        </Row>
        <Divider />
        <DetallesSection detalles={detalles} dispatch={detallesDispatcher} />
      </Portlet.Body>
    </Portlet>
  )
}

export default DetallesSectionPortlet
